import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _menuIcon;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as mixins from '~utils/mixins';
import { media } from '~theme/breakpoints';
export var wrapper = {
  bg: 'header.bg',
  position: 'relative',
  zIndex: 1,
  borderBottom: function borderBottom(t) {
    return "1px solid " + t.colors.border;
  }
};

if (typeof wrapper !== 'undefined' && wrapper && wrapper === Object(wrapper) && Object.isExtensible(wrapper) && !wrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapper",
      filename: "node_modules/gatsby-theme-docz/src/components/Header/styles.js"
    }
  });
}

export var innerContainer = _objectSpread(_objectSpread({}, mixins.centerAlign), {}, {
  px: 4,
  position: 'relative',
  justifyContent: 'space-between',
  height: 80
});

if (typeof innerContainer !== 'undefined' && innerContainer && innerContainer === Object(innerContainer) && Object.isExtensible(innerContainer) && !innerContainer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(innerContainer, '__filemeta', {
    configurable: true,
    value: {
      name: "innerContainer",
      filename: "node_modules/gatsby-theme-docz/src/components/Header/styles.js"
    }
  });
}

export var menuIcon = (_menuIcon = {
  display: 'none',
  position: 'absolute',
  top: 'calc(100% + 15px)',
  left: 30
}, _menuIcon[media.tablet] = {
  display: 'block'
}, _menuIcon);

if (typeof menuIcon !== 'undefined' && menuIcon && menuIcon === Object(menuIcon) && Object.isExtensible(menuIcon) && !menuIcon.hasOwnProperty('__filemeta')) {
  Object.defineProperty(menuIcon, '__filemeta', {
    configurable: true,
    value: {
      name: "menuIcon",
      filename: "node_modules/gatsby-theme-docz/src/components/Header/styles.js"
    }
  });
}

export var menuButton = _objectSpread(_objectSpread({}, mixins.ghostButton), {}, {
  color: 'header.text',
  opacity: 0.5,
  cursor: 'pointer'
});

if (typeof menuButton !== 'undefined' && menuButton && menuButton === Object(menuButton) && Object.isExtensible(menuButton) && !menuButton.hasOwnProperty('__filemeta')) {
  Object.defineProperty(menuButton, '__filemeta', {
    configurable: true,
    value: {
      name: "menuButton",
      filename: "node_modules/gatsby-theme-docz/src/components/Header/styles.js"
    }
  });
}

export var headerButton = _objectSpread(_objectSpread({}, mixins.centerAlign), {}, {
  outline: 'none',
  p: '12px',
  border: 'none',
  borderRadius: 9999,
  bg: 'header.button.bg',
  color: 'header.button.color',
  fontSize: 0,
  fontWeight: 600,
  cursor: 'pointer'
});

if (typeof headerButton !== 'undefined' && headerButton && headerButton === Object(headerButton) && Object.isExtensible(headerButton) && !headerButton.hasOwnProperty('__filemeta')) {
  Object.defineProperty(headerButton, '__filemeta', {
    configurable: true,
    value: {
      name: "headerButton",
      filename: "node_modules/gatsby-theme-docz/src/components/Header/styles.js"
    }
  });
}

export var editButton = _objectSpread(_objectSpread({}, mixins.centerAlign), {}, {
  position: 'absolute',
  bottom: -40,
  right: 30,
  bg: 'transparent',
  color: 'muted',
  fontSize: 1,
  textDecoration: 'none',
  borderRadius: 'radius'
});

if (typeof editButton !== 'undefined' && editButton && editButton === Object(editButton) && Object.isExtensible(editButton) && !editButton.hasOwnProperty('__filemeta')) {
  Object.defineProperty(editButton, '__filemeta', {
    configurable: true,
    value: {
      name: "editButton",
      filename: "node_modules/gatsby-theme-docz/src/components/Header/styles.js"
    }
  });
}